import ApiCaller from './ApiCaller';
import baseAjaxConfig from './BaseAjaxConfig';

export const GET_RECENTLY_VIEWED_REQUEST = 'GET_RECENTLY_VIEWED_REQUEST';
export const GET_RECENTLY_VIEWED_SUCCESS = 'GET_RECENTLY_VIEWED_SUCCESS';
export const GET_RECENTLY_VIEWED_ERROR = 'GET_RECENTLY_VIEWED_ERROR';

export function getRecentlyViewedAction(products) {
	return { type: GET_RECENTLY_VIEWED_REQUEST, products };
}

export function getRecentlyViewedSuccessAction(data, products) {
	return { type: GET_RECENTLY_VIEWED_SUCCESS, data, products };
}

export function getRecentlyViewedErrorAction(error, products) {
	return { type: GET_RECENTLY_VIEWED_ERROR, error, products };
}

export function fetchRecentlyViewedSummaryAction(products) {
	return (dispatch, getState) => {
		if (!products || !products.length) {
			return null;
		}
		dispatch(getRecentlyViewedAction(products));

		const payload = {
			requestContext: { products }
		};
		return ApiCaller.post(
			Object.assign({}, baseAjaxConfig, {
				pathname: '/api/3/product/summary'
			}),
			payload
		).then(
			json => dispatch(getRecentlyViewedSuccessAction(json['RESPONSE'], products)),
			err => {
				dispatch(getRecentlyViewedErrorAction(err, products));
				return Promise.reject(err);
			}
		);
	};
}
